import { SolanaWithSignerBaseCommand } from '../../../../solana';

import { web3 } from '@coral-xyz/anchor';
import { Flags } from '@oclif/core';
import { State } from '@switchboard-xyz/on-demand';

export default class PriceWhitelist extends SolanaWithSignerBaseCommand {
  static enableJsonFlag = true;

  static description = 'Create an oracle account';

  static flags = {
    ...SolanaWithSignerBaseCommand.flags,
    addAuthority: Flags.string({
      description: 'Feed authority to price whitelist',
      required: false,
    }),
    rmAuthority: Flags.string({
      description: 'Feed authority to remove price whitelist',
      required: false,
    }),
  };

  static args = {};

  async run() {
    const { flags } = await this.parse(
      this.constructor as typeof PriceWhitelist
    );

    const program = await this.program;
    const state = new State(program);

    const stateData = await state.loadData();
    let addAuthority = web3.PublicKey.default;
    const rmAuthority = web3.PublicKey.default;
    if (flags.addAuthority) {
      addAuthority = new web3.PublicKey(flags.addAuthority);
    }
    if (flags.rmAuthority) {
      addAuthority = new web3.PublicKey(flags.rmAuthority);
    }
    const ix = await program.instruction.stateSetCosts(
      {
        addAuthority,
        rmAuthority,
      },
      {
        accounts: {
          state: state.pubkey!,
          authority: stateData.authority!, // authority needs to be a valid signer
          payer: this.keypair.publicKey, // payer signs and covers transaction fees
          systemProgram: web3.SystemProgram.programId!,
        },
      }
    );

    await this.signAndSend([ix]);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async catch(error: any) {
    super.catch(error, 'failed to configure state account');
  }
}
